import React from 'react';
import BaseNode from './BaseBlockNode';
import { makeParams } from '../../helpers/node';
import { ChargingPolicyNodeConfig } from '../../../constants';

function ChargingPolicyNode(props) {
  return (
    <BaseNode
      {...props}
      phases={null}
      dynamicParams={makeParams(ChargingPolicyNodeConfig().dynamicParams)(props)}
    />
  );
}

export default ChargingPolicyNode;
